import { Component, OnInit, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { Job } from '@app/model/job';
import { User } from '@app/model/user';
import { MessageService, SelectItem } from 'primeng/api';
import { NgForm, ReactiveFormsModule } from '@angular/forms';
import { Messages } from '@app/constants/constant';
import { QueryOptions } from '@app/model/query-options';
import { Router, NavigationEnd } from '@angular/router';
import { stringify } from 'querystring';
import { AuthenticationService } from '@app/services/authentication.service';
import {CvSubmit} from '@app/model/cvSubmit';

@Component({
    selector: 'app-cvsubmit-popup',
    templateUrl: './cvsubmit.component.html',
    styleUrls: ['./cvsubmit.component.css']
})
export class CvsubmitComponent implements OnInit {
    cvSubmitted: number | string;
    cvShortListed: number | string;
    JdName: string;
    jdId: string;
    recruiterId: string;
    recruiterName: string;
    submitDate: string;
    jobId: string;
    showCloseIcon: false;
    @Input() display: boolean;
    @Output() displayFunction = new EventEmitter<boolean>();
    @Output() reloadTable = new EventEmitter<boolean>();
    selectedRecruiters: User[] = [];
    selectedRecruiterUser: User[] = [];
    @Input() fields: CvSubmit;
    items: [] = [];
    pageSize = 500;
    first = 0;
    @ViewChild('cvSubmitForm', { static: false }) public assignRecruiterForm: NgForm;
    options: SelectItem[];
    modalTitle:string;
    // tslint:disable-next-line:variable-name
    constructor(private _toastService: MessageService) {
    }

    ngOnInit() {
        const sortParams = this.queryParams();
        this.getAllAssignedRecruiters();
    }

    ngDoCheck() {
        if (this.display == true && this.fields != null) {
            this.cvSubmitted = this.fields.cvSubmitted ? this.fields.cvSubmitted : '';
            this.cvShortListed = this.fields.cvShortListed ? this.fields.cvShortListed : '';
            this.JdName = this.fields.jdName ? this.fields.jdName : '';
            this.jdId = this.fields.jdId;
            this.recruiterId = this.fields.recruiterId;
            this.recruiterName = this.fields.recruiterName;
            this.submitDate = this.fields.submitDate;
        }
    }

    queryParams() {
        const queryParams = new Object();
        const dropDownSortingQueryOptions = new QueryOptions(queryParams);
        dropDownSortingQueryOptions.toQueryMap();
        return dropDownSortingQueryOptions;
    }

    getAllAssignedRecruiters = function() {
        const queryParams = new Object();
        const assignRecruitersQueryOption = new QueryOptions(queryParams);
        assignRecruitersQueryOption.queryMap.set('cvSubmit', this.fields.id);
        assignRecruitersQueryOption.queryMap.set('cvSubmit', this.fields.jdId);
        assignRecruitersQueryOption.queryMap.set('cvSubmit', this.fields.submitDate);
        assignRecruitersQueryOption.toQueryMap();
        this._JobRecruiterMappingServiceGet.list(assignRecruitersQueryOption).subscribe(res => {
            this.records = res;
            for (const val of this.records) {
                this.selectedRecruiters.push(val.users.id);
            }
        });
    };

    assignRecruiter = function(assignRecruiterForm) {
        this.reloadTable.emit(false);
        this.jobId = this.fields.id;
        this.comment = this.assignRecruiterForm.value.comments ? this.assignRecruiterForm.value.comments : '';
        this.selectedRecruiter = this.assignRecruiterForm.value.recruiters ? this.assignRecruiterForm.value.recruiters : [];
        //const JobRecruiters = new JobRecruiter();
        //const jobComment = new JobComment();
        //for (const p of this.selectedRecruiter) {
        //    this.selectedRecruiterUser.push(new User(p));
        //}//
        //JobRecruiters.users = this.selectedRecruiterUser;
        //JobRecruiters.jobId = this.jobId,

        //    jobComment.job = this.jobId;
        //jobComment.createdBy = this._authenticationService.currentUserValue ? this._authenticationService.currentUserValue.user : '';
        //jobComment.description = this.comment;
        //jobComment.name = 'N/A';

        //JobRecruiters.comment = jobComment;
        /*this._JobRecruiterMappingService.create(JobRecruiters).subscribe(
            res => {
                this.newJobRecruiter = res;
                this.showJobRecruiterToast();
                this.assignRecruiterForm.reset();
                this.showDialog(false);
            }, (err) => { this._toastService.add({ severity: 'error',
                summary: Messages.recruiterAssignedError,
                detail: Messages.tryAgain });
                          this.showDialog(false);
            }
        );*/
    };

    showDialog = function(bool: boolean) {
        this.displayFunction.emit(bool);
        this.cvSubmitForm.reset();
        this.reloadTable.emit(true);
    };

    showJobRecruiterToast = function() {
        this._toastService.add({
            severity: 'success',
            summary: Messages.recruiterAssignedSuccess,
            detail: '' });
    };

    updateCVSubmit(cvSubmitForm:NgForm){
        console.log(cvSubmitForm)
    }
}
